import { resolveWorkflowAppIcon } from './resolveWorkflowAppIcon.js'

/** @param {string[]} tags */
export function resolveWorkflowAppIcons(tags) {
  return (tags ?? []).map(resolveWorkflowAppIcon)
}
